var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 187 183",
    width: 187,
    height: 183,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 11827-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #bcbeff } \n\t\t.s1 { fill: #807ffb } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m151.9 93.4l-23.1-53.4c-1.9-4.4-5.4-8.1-9.8-10.3-4.3-2.3-9.3-2.9-13.8-1.9l-55.8 13c-3.7 0.9-7.1 2.5-10 4.8-2.8 2.3-5.1 5.1-6.6 8.4l-5.9 13c-1.6 3.4-1.7 7.4-0.2 11.2l21.3 56.8c0.8 2 1.9 4 3.5 5.7 1.5 1.7 3.3 3.1 5.3 4.2 2.1 1.1 4.3 1.8 6.5 2 2.2 0.3 4.4 0.2 6.5-0.4l61.1-16.2c6.1-1.6 11.4-5 15-9.8l3.9-5.2c2.2-3 3.6-6.6 4-10.4 0.4-3.8-0.3-7.8-1.9-11.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m107.5 47c0.8 1.9 2.5 3.6 4.5 4.5 2 1 4.2 1.2 6.2 0.6 3.8-1.5 5.1-6.1 3-10.3-2.1-4.3-6.9-6.6-10.7-5.1-3.8 1.4-5.1 6-3 10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m64.2 60.6c2.1 4.3 6.9 6.6 10.7 5.1 3.8-1.4 5.1-6 3-10.3-2.1-4.2-6.9-6.5-10.7-5.1-3.8 1.5-5.1 6.1-3 10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m121.1 86.6c2.1 4.2 6.9 6.5 10.7 5.1 3.8-1.4 5.1-6 3-10.3-2.2-4.3-6.9-6.5-10.7-5.1-3.8 1.4-5.2 6-3 10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m77.8 100.3c2.1 4.3 6.9 6.6 10.7 5.1 3.7-1.4 5.1-6 3-10.3-2.2-4.2-7-6.5-10.7-5.1-3.8 1.5-5.2 6.1-3 10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m91.3 73c2.1 4.3 6.9 6.6 10.7 5.1 3.8-1.4 5.1-6 3-10.3-2.1-4.2-6.9-6.5-10.7-5.1-3.8 1.5-5.1 6-3 10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m96.5 131.5c0.6 1.1 5.1 0.4 10.1-1.5 5.1-2 8.7-4.4 8.2-5.5-0.5-1-5.1-0.3-10.1 1.6-5.1 1.9-8.8 4.3-8.2 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m32.1 82.4c1.2 3.8 2.9 6.7 3.8 6.6 0.9-0.2 0.6-3.4-0.5-7.2-1.1-3.7-2.9-6.6-3.8-6.5-0.8 0.1-0.6 3.4 0.5 7.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m41.9 99.3c1.2 3.7 2.9 6.6 3.8 6.5 0.9-0.1 0.6-3.4-0.6-7.2-1.2-3.7-2.9-6.6-3.7-6.5-0.9 0.1-0.7 3.4 0.5 7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m51.8 116.1c1.2 3.8 2.9 6.7 3.7 6.5 0.9-0.1 0.7-3.3-0.4-7.1-1.2-3.7-2.9-6.6-3.8-6.5-0.9 0.1-0.6 3.4 0.6 7.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDice);
export default __webpack_public_path__ + "static/media/dice.02fa066db79cf4fd4a3f0595fc56410a.svg";
export { ForwardRef as ReactComponent };